import type { TrainingMode } from "@/features/training/queries";
import { cn } from "@/lib/cn";

interface ModeCardProps {
  mode: TrainingMode;
  selected: boolean;
  onClick: () => void;
}

export function ModeCard({ mode, selected, onClick }: ModeCardProps) {
  const disabled = !mode.available;
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      title={disabled ? mode.reason_if_unavailable : undefined}
      className={cn(
        "flex flex-col items-start gap-1 rounded-md border bg-surface px-3 py-2.5 text-left transition-colors",
        "text-xs font-medium",
        selected
          ? "border-accent ring-2 ring-accent/30 text-fg"
          : "border-border-strong text-fg hover:border-fg-dim",
        disabled && "cursor-not-allowed opacity-50 hover:border-border-strong",
      )}
    >
      <span className="flex items-center gap-2">
        <span className="font-mono text-[11px] font-semibold uppercase tracking-[0.04em]">
          {mode.name}
        </span>
        {mode.available ? (
          <span className="rounded bg-emerald-500/10 px-1.5 py-0.5 font-mono text-[9px] font-semibold uppercase tracking-wider text-emerald-700 dark:text-emerald-300">
            Available
          </span>
        ) : (
          <span className="rounded bg-zinc-500/10 px-1.5 py-0.5 font-mono text-[9px] font-semibold uppercase tracking-wider text-zinc-500">
            Disabled
          </span>
        )}
      </span>
      {mode.description && (
        <span className="text-[11px] leading-tight text-muted">{mode.description}</span>
      )}
    </button>
  );
}
